'use client';

import React, { useEffect } from 'react';
import { mapModifiers, scrollToElement } from '@/utils/funtion';
import IndicatorSession from '@/components/templates/indicator-session';
import { useSearchParams } from 'next/navigation';
import { LOCAL_TAG_SLUGS, SCREEN } from '@/statics/constants';
import { IndicatorGroupSession } from '@/components/templates/indicator-group-session';
import IndicatorTable from '@/components/templates/indicator-table';
import useGetTableData from '@/helpers/useGetTableData';
import LazyComponent from '@/components/molecules/lazyComponent';
import { useData } from '@/stores/context';
interface IProps {
  slugs: any;
}

function LocalDataModule(props: IProps) {
  const searchParams = useSearchParams();
  const { slugs } = props;
  const { tableData, loading } = useGetTableData(LOCAL_TAG_SLUGS.CNKTDP);
  const { innerWidth } = useData();

  useEffect(() => {
    const slug = searchParams?.get('slug');
    if (slug) {
      const element = document.getElementById(slug) as any;
      if (element) {
        setTimeout(() => {
          scrollToElement(element);
        }, 700);
      }
    }
  }, [searchParams]);

  return (
    <div className={mapModifiers('indicator-data-module')}>
      <div className="indicator-data-module-wrapper">
        <div className="page-title">Kinh tế vùng và địa phương</div>
        <IndicatorTable tableData={tableData} loading={loading} />
        <div
          id={LOCAL_TAG_SLUGS.KTDPTH}
          style={{ minHeight: innerWidth > 1200 ? 708 : 0 }}
        >
          <LazyComponent>
            <IndicatorSession
              screen={SCREEN.LOCAL}
              slug={LOCAL_TAG_SLUGS.KTDPTH}
            />
          </LazyComponent>
        </div>
        {(() => {
          const filteredSlugs = slugs?.filter(
            (item: any) =>
              item?.slug !== 'cap-nhat-kinh-te-dia-phuong' &&
              item?.slug !== 'kinh-te-dia-phuong-tong-hop',
          );

          if (filteredSlugs.length > 2) {
            [filteredSlugs[1], filteredSlugs[2]] = [
              filteredSlugs[2],
              filteredSlugs[1],
            ];
          }

          return filteredSlugs.map((item: any, index: any) => (
            <div
              key={index}
              id={item?.slug}
              style={{ minHeight: innerWidth > 1200 ? 708 : 0 }}
            >
              <LazyComponent key={index} id={item?.slug}>
                <IndicatorGroupSession
                  type="local_indicator"
                  screen={SCREEN.LOCAL}
                  slug={item?.slug}
                />
              </LazyComponent>
            </div>
          ));
        })()}
      </div>
    </div>
  );
}

export default LocalDataModule;
